//=================================================================================================
// SCRIPTING
//=================================================================================================

<script>
import Vue       from 'vue';
import Component from 'vue-class-component';
import Tooltip   from '@/components/Tooltip';

@Component({
	components : {
		Tooltip,
	},
	props      : {
		icon     : String,
		type     : String,
		text     : String,
		toggled  : Boolean,
		disabled : Boolean,
		action   : Function,
	},
})
export default class ButtonIcon extends Vue {
	onClick () {
		if (!!this.action) this.action();
	}
}
</script>

//=================================================================================================
// TEMPLATING
//=================================================================================================

<template>
<div
	@click = "onClick"
	:class = "{ toggled, disabled }"
	class  = "button-icon-root"
>
	<FontAwesomeIcon
		:icon = "[ !!type ? type : 'fas', icon ]"
		size  = "lg"
		class = "inner"
	/>

	<Tooltip
		v-if  = "!!text"
		:text = "text"
		class = "tooltip"
	/>
</div>
</template>

//=================================================================================================
// STYLING
//=================================================================================================

<style lang="scss" scoped>
@import '../assets/scss/colour.scss';

.button-icon-root {
	user-select                 : none;
	position                    : relative;
	display                     : inline-flex;
	justify-content             : center;
	align-items                 : center;
	width                       : 22px;
	height                      : 22px;
	margin                      : 2px;
	border                      : 2px solid $c--text;
	border-radius               : 3px;
	transition-property         : color, border-color;
	transition-duration         : 0.3s;

	&:hover {
		color                       : $c--highlight;
		border-color                : $c--highlight;

		.tooltip {
			opacity                 : 1.0;
		}
	}

	&:active:not(.disabled) {
		.inner {
			transform                   : scale(0.9);
		}
	}

	&.toggled {
		color                       : $c--toggled;
	}

	&.disabled {
		color                       : $c--disabled;
		border-color                : $c--disabled;
	}
}
</style>
